// base
import { date } from '@/helper/locale/base/base_date.en.js';
import { button } from '@/helper/locale/base/base_button.en.js';
import { iimmpact } from '@/module/Iimmpact/locale/iimmpact.en';
// module

export const en = {
    // base
    date: date,
    button: button,
    // module

    iimmpact: iimmpact,
};
